module.exports = __webpack_public_path__ + "static/media/Tunisia.8e52b555.png";